<template>
    <div style="height:1551px ;  position: relative;">
        <div style="background: #F5F5F5;">
            <TitleView :titleData="resultData" />
            <div class="content-box">
                <div class="title ">
                    <span class="content-title">脊柱功能评估</span>
                    <div class="content-right-label">*报告内容仅供参考，不作为诊断或医疗依据备份</div>
                </div>

                <div class="content-img-box">
                    <div class="content-img-box-item-left" id="canvasContainer" ref="canvasContainer">
                        <div class="content-box-item-left-title">背面</div>
                        <img class="content-bg-img" :src="imgUrl" />
                        <div class="content-box-item-right-bottom">C7 S1 PSIS GEQL<br />
                            S1 颈椎7<br />
                            PSIS 骶骨中点<br />
                            G 骼后上棘<br />
                            G7 人体重心<br />
                            EQL 二等分线 <br /></div>
                    </div>
                    <div class="content-img-box-item-right">
                        <div class="content-box-item-left-title">右侧面</div>
                        <img class="content-bg-img" src="../assets/report-3d-preview.png" />
                        <div class="content-box-item-left-bottom">C7 S1 PSIS GEQL<br />
                            S1 颈椎7<br />
                            G 骼后上棘</div>
                    </div>
                </div>
                <div style="display: flex; margin-top: 18px;">
                    <div
                        style="display: flex; flex-direction: column; width: 501px; text-align: left;margin-left: 26px;">
                        <span style="font-size: 19px; color: #02C58F; font-weight: 500;">评估结论1</span>
                        <span style="font-size: 19px; color: #333333; font-weight: 400;">评估结论2</span>
                    </div>
                    <div
                        style="display: flex; flex-direction: column; width: 501px; text-align: left;margin-left: 26px;">
                        <span style="font-size: 19px; color: #02C58F; font-weight: 500;">评估结论1</span>
                        <span style="font-size: 19px; color: #333333; font-weight: 400;">评估结论2</span>
                    </div>
                </div>
            </div>
        </div>
        <div style="display: flex; position: absolute;bottom: 0; ">
            <img style=" width: 1100px; height: 18px; " src="../assets/ic-bottom-img.png" />
        </div>
    </div>
</template>

<script>

import TitleView from "@/views/TitleView.vue";
export default {
    props: {
        resultData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            imgUrl: "https://health-mirror.oss-cn-beijing.aliyuncs.com/actions/977/dca7645a04634ddaa991cab30c4ed761.jpg"
        }
    },
    created() {

    },
    components: {
        TitleView,
    },
    mounted() {
        this.canvasOne()
        this.canvasTwo()
        this.canvasFillText()
    },
    methods: {
        //直线
        canvasOne() {
            const canvasContainer = this.$refs.canvasContainer;
            const canvas = document.createElement('canvas');
            canvas.width = canvasContainer.clientWidth;
            canvas.height = canvasContainer.clientHeight;
            canvas.style.position = 'absolute';
            canvas.style.top = '0';
            canvas.style.left = '0';
            canvasContainer.appendChild(canvas);

            const ctx = canvas.getContext('2d');

            // 计算竖线的位置（这里简单地将竖线画在画布的中间）
            const x = canvas.width / 2;

            // 绘制竖线
            ctx.beginPath();
            ctx.moveTo(x, 30); // 起点坐标
            ctx.lineTo(x, canvas.height - 30); // 终点坐标
            ctx.strokeStyle = 'black'; // 线条颜色
            ctx.lineWidth = 1; // 线条宽度
            ctx.stroke(); // 绘制线条
        },
        //虚线
        canvasTwo() {
            const canvasContainer = this.$refs.canvasContainer;
            const canvas = document.createElement('canvas');
            canvas.width = canvasContainer.clientWidth;
            canvas.height = canvasContainer.clientHeight;
            canvas.style.position = 'absolute';
            canvas.style.top = '0';
            canvas.style.left = '0';
            canvasContainer.appendChild(canvas);

            const ctx = canvas.getContext('2d');

            const dashLength = 5; // 虚线每段的长度
            const spaceLength = 2; // 虚线之间的空白长度
            const dashArray = [dashLength, spaceLength];

            // 计算竖线的位置（这里简单地将竖线画在画布的中间）
            const x = canvas.width / 2 + 10;

            ctx.setLineDash(dashArray); // 设置虚线样式
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'blue';
            ctx.beginPath();
            ctx.moveTo(x, 30); // 起点坐标
            ctx.lineTo(x, canvas.height - 30); // 终点坐标
            ctx.stroke();
        },
        //文字
        canvasFillText() {
            const canvasContainer = this.$refs.canvasContainer;
            const canvas = document.createElement('canvas');
            canvas.width = canvasContainer.clientWidth;
            canvas.height = canvasContainer.clientHeight;
            canvas.style.position = 'absolute';
            canvas.style.top = '0';
            canvas.style.left = '0';
            canvasContainer.appendChild(canvas);
            const ctx = canvas.getContext('2d');

            // 计算竖线的位置（这里简单地将竖线画在画布的中间）
            const x = canvas.width / 2;
            const y = canvas.width / 2;

            //偏移量
            const offsetX = 25;
            const offsetY = 10;

            // 绘制背景
            ctx.fillStyle = '#DDE2E6';
            ctx.fillRect(x + offsetX, y - offsetY, 50, 25);

            //绘画文字
            ctx.font = '20px Arial';
            ctx.fillStyle = '#00BD8A';
            ctx.fillText('PSIS', x + offsetX, y + offsetY);

            // 画圆点
            const radius = 4; // 设置圆点半径
            const dotSize = radius * 2; // 圆点直径

            // 画实心圆点
            ctx.beginPath();
            ctx.arc(x + 10, y, radius, 0, 2 * Math.PI);
            ctx.fillStyle = '#00BD8A'; // 设置圆点颜色
            ctx.fill();
        }


    },
}
</script>
<style scoped>
.content-box {
    display: flex;
    background: #ffffff;
    margin: 25px 31px;
    padding: 9px 13px;
    flex-direction: column;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.content-title {
    font-weight: 500;
    font-size: 19px;
    color: #333333;
}

.content-right-label {
    font-weight: 400;
    font-size: 9px;
    color: #7F7F7F;
    text-align: right;
}

.content-img-box {
    display: flex;
    margin-top: 10px;
}

.content-img-box-item-left {
    display: flex;
    background: #F6FBFA;
    justify-content: center;
    align-items: center;
    width: 501px;
    height: 760px;
    position: relative;
}



.content-img-box-item-right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 501px;
    height: 760px;
    background: #F6FBFA;
    margin-left: 10px;
    align-items: center;
    position: relative;

}

.content-box-item-left-title {
    position: absolute;
    top: 26px;
    left: 26px;
    font-weight: 400;
    font-size: 19px;
    color: #333333;
}

.content-box-item-right-bottom {
    position: absolute;
    bottom: 26px;
    right: 26px;
    font-weight: 400;
    font-size: 19px;
    color: #333333;
    font-weight: 400;
    font-size: 11px;
    color: #333333;
    text-align: left;
}

.content-box-item-left-bottom {
    position: absolute;
    bottom: 26px;
    left: 26px;
    font-weight: 400;
    font-size: 19px;
    color: #333333;
    font-weight: 400;
    font-size: 11px;
    color: #333333;
    text-align: left;
}

.content-bg-img {
    width: 328px;
    height: 645px;
}
</style>